module.exports = __webpack_public_path__ + "mainassets/img/graf3-2.25eac204.svg";